import { component } from 'picoapp';


class DownloadReportValidation extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

    this.buttons = this.closest(".download-report-button").querySelectorAll('.wp-block-button__link')

    this.buttons.forEach(b => {

      const href = b.href
      if (!localStorage.getItem("enable-download-report")) {
        b.removeAttribute("href")
      }

      b.addEventListener('click', e => {
        if (localStorage.getItem("enable-download-report")) {
          b.href = href
        } else {
          e.preventDefault()
          jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
            if (formId == "2") {
              window.open(href);
            }
          })
          window.app.emit('Modal', { identifier: 'download-report-modal', action: 'toggle' })
        }
      })
    })
  }
}

export default component((node, ctx) => {
  if (!customElements.get('download-report-validation')) {
    customElements.define('download-report-validation', DownloadReportValidation);
  }
});
